/**
 * Domaine du site qui affiche le widget ("studiolac.ch").
 *
 * `ancestorOrigins` (Chrome, Safari) vient du navigateur. Firefox ne l'a pas :
 * on retombe sur `returnUrl`, que embed.js remplit avec l'origine de la page.
 * L'iframe est en `referrerpolicy="no-referrer"`, document.referrer est vide.
 */
export function getHostDomain(): string | null {
  if (typeof window === "undefined") return null;

  const fromBrowser = window.location.ancestorOrigins?.[0];
  const fromSnippet = new URLSearchParams(window.location.search).get("returnUrl");

  for (const candidate of [fromBrowser, fromSnippet]) {
    if (!candidate) continue;
    try {
      return new URL(candidate).hostname;
    } catch {
      /* origine illisible : on essaie la suivante */
    }
  }
  return null;
}

/**
 * La page du site hote ("https://studiolac.ch/planning"), sans parametres.
 * Notee sur les reservations (bookings.host_url) ; un paiement TWINT sorti de
 * l'iframe y ramene l'eleve.
 */
export function getHostUrl(): string | null {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  const origin = params.get("returnUrl");
  if (!origin) return null;
  try {
    return new URL(params.get("hostPath") || "/", origin).toString();
  } catch {
    return null;
  }
}

/**
 * L'adresse de ce widget, ou Stripe revient apres TWINT. Sans les marqueurs
 * d'un retour precedent, que l'API remplace par ceux du nouveau paiement.
 */
export function getWidgetReturnUrl(): string {
  const url = new URL(window.location.href);
  url.hash = "";
  url.searchParams.delete("bz_booking");
  url.searchParams.delete("payment_return");
  return url.toString();
}
